// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__33t20","title":"ClientReferral_title__2HyxP","itemText":"ClientReferral_itemText__1E3Le"};